import { clsx } from "clsx";
import type { HTMLAttributes, ReactNode } from "react";

type GlassCardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  tone?: "light" | "tinted";
  /** false for cards whose content runs edge to edge (the comparison tables). */
  padded?: boolean;
};

// Frosted surface for feature, pricing and legal-page blocks. `tinted` adds a faint violet wash for
// the one card in a row that should lead (the featured plan, the recommended option).
export function GlassCard({ children, className, tone = "light", padded = true, ...rest }: GlassCardProps) {
  return (
    <div
      {...rest}
      className={clsx(
        "rounded-3xl",
        padded && "p-6 sm:p-8",
        tone === "light" && "glass",
        tone === "tinted" && "glass bg-gradient-to-br from-white/75 via-[#efedfb]/70 to-white/60",
        className
      )}
    >
      {children}
    </div>
  );
}
